import React from 'react';
import { IInvoiceReminder } from '../../types/types';
import Heading from '../../../../../generic-components/Heading';
import ToggleButton from '../../../InvoiceOnboarding/components/ToggleButton';
import { getFutureDateFromSpecificDate, getPriorDateFromSpecificDate } from '../../../../../helpers/datesAndTime.helper';
import { refactoredTimeAndDate } from '../../../../../helpers/timeFormatter.helper';
import { DATE_FORMAT } from '../../../../../constants/general';
import { STYLES } from '../../consts/consts';

const { INVOICE_CREATION: { INVOICE_REMINDER_ITEM: componentStyles } } = STYLES;

interface IProps {
  reminderData: IInvoiceReminder;
  handleToggle: (type: string) => void;
  dueDate: Date;
}

export const ReminderItem = ({ reminderData, handleToggle, dueDate }: IProps) => {
  const formatDate = (date: Date) => refactoredTimeAndDate(
    date.toDateString(),
    'InvoiceCreation',
    DATE_FORMAT.LETTERS,
    false,
  );

  const getDateString = () => {
    let date: Date;
    if (reminderData.numberOfDays < 0) {
      date = getPriorDateFromSpecificDate(reminderData.numberOfDays, dueDate);
    } if (!reminderData.numberOfDays) {
      date = dueDate;
    } else {
      date = getFutureDateFromSpecificDate(reminderData.numberOfDays, dueDate);
    }
    return formatDate(date);
  };
  return (
    <div className={`${reminderData.selected ? componentStyles.SELECTED : ''} ${componentStyles.WRAPPER}`}>
      <div className={componentStyles.TITLES_WRAPPER}>
        <Heading title={reminderData.reminderText} className={componentStyles.REMINDER_TEXT} />
        <Heading title={getDateString()} className={componentStyles.DUE_DATE} />
      </div>
      <ToggleButton toggleState={reminderData.selected} toggle={() => handleToggle(reminderData.invoiceReminderType)} buttonId={`DueDateToggle-${reminderData.invoiceReminderType}`} />
    </div>
  );
};
